<template>
	<div class="register-view">
		<div class="register-content">
			<div class="register-form">
				<div class="register-brand">
					<img class="logo" src="../../public/logo-128.png" />
					<div>注册傻蛋AI</div>
				</div>
				<el-form :model="registerForm" status-icon :rules="rules" ref="registerForm" label-width="80px">
					<el-form-item label="用户名" prop="userName">
						<el-input type="userName" v-model="registerForm.userName" autocomplete="off"
							placeholder="用户名(登录使用)"></el-input>
					</el-form-item>
					<el-form-item label="昵称" prop="nickName">
						<el-input type="nickName" v-model="registerForm.nickName" autocomplete="off"
							placeholder="昵称"></el-input>
					</el-form-item>
					<el-form-item label="密码" prop="password">
						<el-input type="password" v-model="registerForm.password" autocomplete="off"
							placeholder="密码"></el-input>
					</el-form-item>
					<el-form-item label="确认密码" prop="confirmPassword">
						<el-input type="password" v-model="registerForm.confirmPassword" autocomplete="off"
							placeholder="确认密码"></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="phone">
						<el-input type="phone" v-model="registerForm.phone" autocomplete="off"
							placeholder="手机号"></el-input>
					</el-form-item>
					<el-form-item label="验证码" prop="code">
						<div class="verification-code-row">
							<el-input v-model="registerForm.code" autocomplete="off" placeholder="请输入验证码"
								class="code-input"></el-input>
							<el-button type="primary" @click="sendCode" :disabled="countdown > 0"
								class="send-code-btn">
								{{ countdown > 0 ? `${countdown}s后重发` : '发送验证码' }}
							</el-button>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="button-group">
							<el-button type="primary" @click="submitForm('registerForm')" class="register-btn">注册</el-button>
							<el-button @click="resetForm('registerForm')" class="reset-btn">清空</el-button>
						</div>
					</el-form-item>
				</el-form>
				<div class="to-login">
					<router-link to="/login">已有账号,前往登录</router-link>
				</div>
			</div>
		</div>
		<icp></icp>
	</div>
</template>

<script>
import Icp from '../components/common/Icp.vue'
import axios from 'axios'

export default {
	name: "login",
	components: {
		Icp
	},
	data() {
		var checkUserName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入用户名'));
			}
			callback();
		};
		var checkNickName = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入昵称'));
			}
			callback();
		};
		var checkPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			callback();
		};

		var checkConfirmPassword = (rule, value, callback) => {
			if (value === '') {
				return callback(new Error('请输入密码'));
			}
			if (value != this.registerForm.password) {
				return callback(new Error('两次密码输入不一致'));
			}
			callback();
		};

		var checkPhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入手机号'));
			}
			const phoneRegex = /^1[3-9]\d{9}$/;
			if (!phoneRegex.test(value)) {
				return callback(new Error('请输入正确的手机号格式'));
			}
			callback();
		};

		var checkCode = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入验证码'));
			}
			callback();
		};

		return {
			countdown: 0, // 倒计时秒数
			timer: null, // 定时器
			registerForm: {
				userName: '',
				nickName: '',
				password: '',
				confirmPassword: '',
				phone: '',
				code: '', // 验证码
				terminalNo:0
			},
			rules: {
				userName: [{
					validator: checkUserName,
					trigger: 'blur'
				}],
				nickName: [{
					validator: checkNickName,
					trigger: 'blur'
				}],
				password: [{
					validator: checkPassword,
					trigger: 'blur'
				}],
				confirmPassword: [{
					validator: checkConfirmPassword,
					trigger: 'blur'
				}],
				phone: [{
					validator: checkPhone,
					trigger: 'blur'
				}],
				code: [{
					validator: checkCode,
					trigger: 'blur'
				}]
			}
		};
	},
	methods: {
		// 发送验证码
		sendCode() {
			// 验证手机号是否输入
			if (!this.registerForm.phone) {
				this.$message.error('请先输入手机号');
				return;
			}

			// 验证手机号格式
			const phoneRegex = /^1[3-9]\d{9}$/;
			if (!phoneRegex.test(this.registerForm.phone)) {
				this.$message.error('请输入正确的手机号格式');
				return;
			}

			// 调用后端发送验证码API
			console.log('发送验证码到手机号:', this.registerForm.phone);

			axios({
				url: "https://shadan.web.service.thinkgs.cn/jeecg-boot/sys/sendsms",
				method: 'post',
				data: { mobile: this.registerForm.phone },
				timeout: 10000
			}).then(response => {
				console.log('验证码发送响应:', response.data);

				if (response.data && response.data.success === true) {
					this.$message.success('验证码已发送');
					// 注意：验证码不存储在前端，由后端 /verifySms 接口验证
					this.startCountdown();
				} else {
					console.error('服务器返回错误:', response.data);
					this.$message.error(response.data.message || '验证码发送失败');
				}
			}).catch(error => {
				console.error('验证码发送失败:', error);

				let errorMessage = '验证码发送失败，请稍后重试';
				if (error.response && error.response.data) {
					const data = error.response.data;
					if (data.success === false) {
						errorMessage = data.message || errorMessage;
					}
				} else if (error.message) {
					errorMessage = error.message;
				}

				this.$message.error(errorMessage);
			});
		},

		// 开始倒计时
		startCountdown() {
			this.countdown = 60;
			this.timer = setInterval(() => {
				this.countdown--;
				if (this.countdown <= 0) {
					clearInterval(this.timer);
					this.timer = null;
				}
			}, 1000);
		},

		async submitForm(formName) {
			this.$refs[formName].validate(async (valid) => {
				if (valid) {
					try {
						// 步骤1：调用后端验证验证码
						console.log('[Register] 开始后端验证码验证，手机号:', this.registerForm.phone);
						const verifyResponse = await axios({
							url: "https://shadan.web.service.thinkgs.cn/jeecg-boot/sys/verifySms",
							method: 'post',
							data: {
								mobile: this.registerForm.phone,
								code: this.registerForm.code
							},
							timeout: 10000
						});

						console.log('[Register] 验证码验证响应:', verifyResponse.data);

						if (!verifyResponse.data.success) {
							this.$message.error(verifyResponse.data.message || "验证码验证失败");
							return;
						}

						// 步骤2：验证成功，执行注册
						console.log('[Register] 验证码验证成功，开始注册');
						await this.$http({
							url: "/register",
							method: 'post',
							data: this.registerForm
						});

						this.$message.success("注册成功!");
						// 注册成功后跳转到登录页面
						setTimeout(() => {
							this.$router.push('/login');
						}, 1500);

					} catch (error) {
						console.error('[Register] 注册失败:', error);
						this.$message.error("注册失败: " + (error.response?.data?.message || error.message));
					}
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		}
	},
	// 组件销毁时清理定时器
	beforeDestroy() {
		if (this.timer) {
			clearInterval(this.timer);
			this.timer = null;
		}
	}
}
</script>

<style scoped lang="scss">
.register-view {
	width: 100%;
	height: 100%;
	background: #E8F2FF;
	background-size: cover;
	box-sizing: border-box;

	.register-content {
		position: relative;
		display: flex;
		justify-content: space-around;
		align-items: center;
		padding: 10%;

		.register-form {
			width: 450px;
			padding: 30px;
			background: white;
			opacity: 0.95;
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
			border-radius: 10px;
			overflow: hidden;

			.register-brand {
				display: flex;
				justify-content: center;
				align-items: center;
				line-height: 50px;
				margin: 20px 0 30px 0;
				font-size: 22px;
				font-weight: 600;
				letter-spacing: 2px;
				text-transform: uppercase;
				text-align: center;

				.logo {
					width: 30px;
					height: 30px;
					margin-right: 10px;
				}
			}

			.button-group {
				display: flex;
				gap: 10px;
				width: 100%;

				.register-btn {
					flex: 1;
					height: 40px;
					font-size: 16px;
					font-weight: 500;
				}

				.reset-btn {
					flex-shrink: 0;
					height: 40px;
				}
			}

			// 验证码行样式
			.verification-code-row {
				display: flex;
				align-items: center;
				gap: 10px;

				.code-input {
					flex: 1;
				}

				.send-code-btn {
					flex-shrink: 0;
					min-width: 100px;
					font-size: 12px;
				}
			}

			.to-login {
				display: flex;
				flex-direction: row-reverse;
				line-height: 40px;
				text-align: left;
				padding-left: 20px;
				margin-top: 20px;
			}
		}
	}
}

// 响应式设计
@media (max-width: 768px) {
	.register-view .register-content {
		padding: 5%;

		.register-form {
			width: 90%;
			padding: 20px;

			.register-brand {
				font-size: 18px;
				margin: 10px 0 20px 0;
			}

			// 移动端表单项样式调整
			:deep(.el-form-item) {
				margin-bottom: 15px;
			}

			:deep(.el-form-item__label) {
				width: 70px !important;
				font-size: 14px;
			}

			:deep(.el-form-item__content) {
				margin-left: 70px !important;
			}

			// 按钮组保持水平对齐
			.button-group {
				margin-left: 0;
			}
		}
	}
}

// 超小屏幕（小于 480px）
@media (max-width: 480px) {
	.register-view .register-content {
		padding: 20px 15px;

		.register-form {
			width: 100%;
			padding: 15px;

			.register-brand {
				font-size: 16px;
				flex-direction: column;
				gap: 10px;

				.logo {
					margin-right: 0;
				}
			}

			// 超小屏幕下按钮组水平排列，两个按钮等宽
			.button-group {
				display: flex;
				flex-direction: row;
				gap: 10px;

				.register-btn,
				.reset-btn {
					flex: 1;
					width: auto;
				}
			}

			// 超小屏幕下表单标签换行显示
			:deep(.el-form-item) {
				flex-direction: column;
				align-items: flex-start;
			}

			:deep(.el-form-item__label) {
				width: 100% !important;
				text-align: left;
				padding: 0 0 5px 0;
			}

			:deep(.el-form-item__content) {
				margin-left: 0 !important;
				width: 100%;
			}
		}
	}
}
</style>
